import MapComponent from "../components/map/MapComponent";
import ReportSidebar from "../components/ReportSidebar";
import FilterSidebar from "../components/FilterSidebar";
import "../styles/home.css";
import { useState, useRef, useEffect } from "react";
import api from "../services/api-service";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

export default function Home() {
  const mapRef = useRef(null);
  const { user } = useContext(AuthContext);

  const [isReportOpen, setIsReportOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const CITY_CENTER = [44.7722, 17.191];

  const [position, setPosition] = useState(CITY_CENTER);
  const [incidents, setIncidents] = useState([]);
  const [pendingIncidents, setPendingIncidents] = useState([]);
  const [radius, setRadius] = useState("");

  useEffect(() => {
    const fetchIncidents = async () => {
      try {
        const res = await api.get("/incidents/approved");
        setIncidents(res.data);
      } catch (err) {
        console.error("Failed to fetch incidents:", err);
      }
    };
    const fetchPendingIncidents = async () => {
      try {
        const res = await api.get("/incidents/pending");
        setPendingIncidents(res.data);
      } catch (err) {
        console.error("Failed to fetch pending incidents:", err);
      }
    };
    fetchIncidents();
    if (user !== null && (user.role === "MODERATOR" || user.role === "ADMIN")) {
      fetchPendingIncidents();
    } else setPendingIncidents([]);
  }, [user]);

  return (
    <div className="home-container">
      <div className="map-container">
        <ReportSidebar
          user={user}
          isOpen={isReportOpen}
          onClose={() => setIsReportOpen(false)}
          position={position}
        />
        <FilterSidebar
          user={user}
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          position={position}
          radius={radius}
          setRadius={setRadius}
          onFilter={(filteredIncidents) => {
            const approved = filteredIncidents.filter(
              (incident) => incident.status === "APPROVED",
            );
            const pending = filteredIncidents.filter(
              (incident) => incident.status === "PENDING",
            );

            setIncidents(approved);
            setPendingIncidents(pending);
          }}
        />
        <MapComponent
          ref={mapRef}
          center={position}
          position={position}
          setPosition={setPosition}
          incidents={incidents}
          setIncidents={setIncidents}
          pendingIncidents={pendingIncidents}
          setPendingIncidents={setPendingIncidents}
          interactive={true}
          radius={radius}
        />

        <div className="map-buttons">
          {user?.role === "USER" && (
            <>
              <button
                className="report-incident-button"
                onClick={() => {
                  if (!isReportOpen) mapRef.current?.focusOnLocation();
                  setIsFilterOpen(false);
                  setIsReportOpen((prev) => !prev);
                }}
              >
                Report Incident
              </button>
            </>
          )}

          <button
            className="geolocation-mode-button"
            onClick={() => {
              mapRef.current?.moveToMyLocation();
            }}
          >
            My Location
          </button>

          <button
            className="filter-incidents-button"
            onClick={() => {
              setIsReportOpen(false);
              setIsFilterOpen((prev) => !prev);
            }}
          >
            Filter Incidents
          </button>
        </div>
      </div>
    </div>
  );
}
